export enum BatchColumnEnum {
    BATCH_NAME = 'BATCH_NAME',
    BATCH_DATE = 'BATCH_DATE',
    BATCH_COUNT = 'BATCH_COUNT',
    BATCH_PREPARING_COUNT = 'BATCH_PREPARING_COUNT',
    BATCH_MANIFESTED_COUNT = 'BATCH_MANIFESTED_COUNT',
    BATCH_IN_TRANSIT_COUNT = 'BATCH_IN_TRANSIT_COUNT',
    BATCH_DELIVERED_COUNT = 'BATCH_DELIVERED_COUNT',
    BATCH_EXCEPTION_COUNT = 'BATCH_EXCEPTION_COUNT',
    BATCH_VOID_COUNT = 'BATCH_VOID_COUNT'
}
